import { render } from "./DriveDeleteConfirm.vue?vue&type=template&id=ffa95bc0&scoped=true&ts=true"
import script from "./DriveDeleteConfirm.vue?vue&type=script&lang=ts"
export * from "./DriveDeleteConfirm.vue?vue&type=script&lang=ts"

import "./DriveDeleteConfirm.vue?vue&type=style&index=0&id=ffa95bc0&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa95bc0"]])

export default __exports__